// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a {\r\n\tcolor: #3388cc;\r\n    font-weight: bold;\r\n}", ""]);
// Exports
module.exports = exports;
